import Record from "./base"

export class Template extends Record {}



// WEBPACK FOOTER //
// ./src/store/serializers/template.js